<template>
  <iframe
    style="width: 100%; height: calc(100vh - 60px - 160px);"
    :src="playUrl"
    frameborder="0"
    id="activity"
  ></iframe>
</template>

<script>
export default {
  props: {
    playUrl: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>